import { ColumnsType } from 'antd/es/table';

export const headerDeclareCapitalBranch: ColumnsType<any> = [
  {
    title: 'Mã cửa hàng',
    dataIndex: 'code',
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'name',
  },
  {
    title: 'Năm phân bổ',
    dataIndex: 'capital_year',
  },
  {
    title: 'Vốn hàng hoá tối thiểu',
    dataIndex: 'cap_order_min',
  },
  {
    title: 'Vốn hàng hoá tối đa',
    dataIndex: 'cap_order_max',
  },
  {
    title: 'Tỉ lệ vốn hàng hoá tối thiểu %',
    dataIndex: 'per_cap_order_min',
  },
  {
    title: 'Tỉ lệ vốn hàng hoá tối đa %',
    dataIndex: 'per_cap_order_max',
  },
  {
    title: 'Vốn mua lại tối thiểu',
    dataIndex: 'cap_reorder_min',
  },
  {
    title: 'Vốn mua lại tối đa',
    dataIndex: 'cap_reorder_max',
  },
  {
    title: 'Tỉ lệ vốn mua lại tối thiểu %',
    dataIndex: 'per_cap_reorder_min',
  },
  {
    title: 'Tỉ lệ vốn mua lại tối đa %',
    dataIndex: 'per_cap_reorder_max',
  },
  {
    title: 'Vốn khác tối thiểu',
    dataIndex: 'cap_other_min',
  },
  {
    title: 'Vốn khác tối đa',
    dataIndex: 'cap_other_max',
  },
  {
    title: 'Tỉ lệ vốn khác tối thiểu %',
    dataIndex: 'per_cap_other_min',
  },
  {
    title: 'Tỉ lệ vốn khác tối đa %',
    dataIndex: 'per_cap_other_max',
  },
  {
    title: 'Danh mục',
    dataIndex: 'pof_type',
  },
  {
    title: 'Tỉ lệ min %',
    dataIndex: 'ratio_min',
  },
  {
    title: 'Tỉ lệ max %',
    dataIndex: 'ratio_max',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'created_at',
  },
  {
    title: 'Người tạo',
    dataIndex: 'created_by',
  },
  {
    title: 'Ngày cập nhập',
    dataIndex: 'updated_at',
  },
  {
    title: 'Người cập nhập',
    dataIndex: 'updated_by',
  },
  {
    title: 'Ngày gửi yêu cầu',
    dataIndex: 'send_approve_at',
  },
  {
    title: 'Ngày tạo 2',
    dataIndex: 'created_at_2',
  },
  {
    title: 'Người tạo 2',
    dataIndex: 'created_by_3',
  },
  {
    title: 'Ngày cập nhập 2',
    dataIndex: 'updated_at_4',
  },
  {
    title: 'Người cập nhập 2',
    dataIndex: 'updated_by_5',
  },
];
